import chalk from "chalk";

export function printJson(data: unknown): void {
  console.log(JSON.stringify(data, null, 2));
}

export function printSuccess(message: string): void {
  console.log(chalk.green("✓"), message);
}

export function printInfo(message: string): void {
  console.log(chalk.blue("ℹ"), message);
}

export function printWarn(message: string): void {
  console.log(chalk.yellow("⚠"), message);
}

export function printError(message: string): void {
  console.error(chalk.red("✗"), message);
}

export function printTable(headers: string[], rows: string[][]): void {
  const widths = headers.map((h, i) =>
    Math.max(h.length, ...rows.map((r) => (r[i] ?? "").length)),
  );
  const headerLine = headers.map((h, i) => h.padEnd(widths[i])).join("  ");
  console.log(chalk.bold(headerLine));
  for (const row of rows) {
    console.log(row.map((c, i) => (c ?? "").padEnd(widths[i])).join("  "));
  }
}

export function formatBytes(bytes: number): string {
  if (bytes < 1024) return `${bytes} B`;
  if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)} KB`;
  return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
}

export function formatDateTime(iso: string): string {
  const date = new Date(iso);
  if (Number.isNaN(date.getTime())) return iso;

  const pad = (n: number) => String(n).padStart(2, "0");
  return [
    date.getFullYear(),
    pad(date.getMonth() + 1),
    pad(date.getDate()),
  ].join("-") + " " + [pad(date.getHours()), pad(date.getMinutes()), pad(date.getSeconds())].join(":");
}
